import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';
import { haveRights } from 'utils';
import { PermissionEnum, RightsEnum } from 'utils/enums';

export interface PermissionConfig {
  entity: PermissionEnum;
  rights?: RightsEnum[];
}

export interface PermissionResult {
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
  canView: boolean;
  loading: boolean;
}

export function usePermissions(config: PermissionConfig): PermissionResult {
  const auth = useAuth();
  const [permissions, setPermissions] = useState<PermissionResult>({
    canCreate: false,
    canUpdate: false,
    canDelete: false,
    canView: false,
    loading: true,
  });

  useEffect(() => {
    const userPermissions = auth?.user?.Permissions;
    const shouldCheck = (right: RightsEnum) =>
      !config.rights || config.rights.includes(right);

    const canUpdate =
      shouldCheck(RightsEnum.UpdateRight) &&
      haveRights(RightsEnum.UpdateRight, config.entity, userPermissions);

    setPermissions({
      canCreate: canUpdate, // Add uses UpdateRight
      canUpdate,
      canDelete:
        shouldCheck(RightsEnum.DeleteRight) &&
        haveRights(RightsEnum.DeleteRight, config.entity, userPermissions),
      canView:
        shouldCheck(RightsEnum.ViewRight) &&
        haveRights(RightsEnum.ViewRight, config.entity, userPermissions),
      loading: false,
    });
  }, [auth?.user?.Permissions, config.entity, config.rights]);

  return permissions;
}

export default usePermissions;

